import { LucideIcon } from 'lucide-react';
import React from 'react';

interface VenereIconBoxProps {
  icon: LucideIcon | React.ComponentType<{ size?: number; color?: string }>;
  size?: number;
  color?: string;
  backgroundColor?: string;
  className?: string;
  onClick?: () => void;
}

const VenereIconBox: React.FC<VenereIconBoxProps> = ({
  icon: IconComponent,
  size = 35,
  color = "var(--venere-skin)",
  backgroundColor = "var(--venere-navy)",
  className = "",
  onClick,
}) => {
  const baseClasses = "flex items-center justify-center rounded-[12px] p-[10px] flex-shrink-0";
  const combinedClasses = `${baseClasses} ${className}`;

  return (
    <div 
      className={combinedClasses}
      style={{ backgroundColor }}
      onClick={onClick}
    >
      <IconComponent size={size} color={color} />
    </div>
  );
};

export default VenereIconBox; 